import * as React from 'react';
import { ChromePicker, ColorResult } from 'react-color';
import { hexToRgb } from '../../utils';
import { getHexFromColor } from '../../utils/PixiUtils';
import { ColorSwatches } from '../components/ColorSwatches';
import {
  FrameSettingsPopover,
  FrameSettingsPopoverProps
} from './FrameSettingsPopover';

interface Props extends FrameSettingsPopoverProps {
  color: string;
  onChange: (color: string) => void;
}

class SolidColorSettingsPopover extends React.Component<Props> {
  colorDidChange = (
    color: ColorResult,
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const hex = getHexFromColor(color);
    this.props.onChange(hex);
  };

  render() {
    const pickerColor = hexToRgb(this.props.color);
    return (
      <FrameSettingsPopover
        className="solid-color-settings-popover"
        trigger={this.props.trigger}
        onClose={this.props.onClose}
        isColorPicker={true}
      >
        <ChromePicker
          disableAlpha={false}
          color={pickerColor}
          onChange={this.colorDidChange}
        />
        <ColorSwatches
          color={this.props.color}
          onChange={this.props.onChange}
        />
      </FrameSettingsPopover>
    );
  }
}

export { SolidColorSettingsPopover };



// WEBPACK FOOTER //
// ./src/controller/settings-popovers/SolidColorSettingsPopover.tsx